export default function () {
    return {
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: 14
                },
            }
        }
    };
}